// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
//
// // Load only English initially (fallback language)
// import english from "./i18n/english.json";
// import hindi from "./i18n/hindi.json";
// import kannada from "./i18n/kannada.json";
// import Marathi from "./i18n/marathi.json";
// import telugu from "./i18n/telugu.json";
// import tamil from "./i18n/tamil.json";
//
// export const defaultNS = "english";
//
// // Language resource loaders - lazy loaded on demand
// const languageLoaders: Record<string, () => Promise<any>> = {
//     en: () => Promise.resolve({ default: english }),
//     hi: () => import("./i18n/hindi.json"),
//     kn: () => import("./i18n/kannada.json"),
//     mr: () => import("./i18n/marathi.json"),
//     tl: () => import("./i18n/telugu.json"),
//     ta: () => import("./i18n/tamil.json"),
// };
//
// // Initialize with English only
// i18n.use(LanguageDetector)
//     .use(initReactI18next)
//     .init({
//         resources: {
//             en: english,
//             hi: hindi,
//             kn: kannada,
//             mr: Marathi,
//             tl: telugu,
//             ta: tamil,
//         },
//         react: {
//             useSuspense: false,
//         },
//         debug: false,
//         fallbackLng: "en",
//         defaultNS,
//         // Load missing languages on demand
//         backend: undefined, // Not using backend, but keeping for future use
//     });
//
// // Lazy load language when needed
// export async function loadLanguage(lng: string): Promise<void> {
//     if (!i18n.hasResourceBundle(lng, defaultNS) && languageLoaders[lng]) {
//         try {
//             const module = await languageLoaders[lng]();
//             const translations = module.default || module;
//             i18n.addResourceBundle(lng, defaultNS, translations, true, true);
//         } catch (error) {
//             console.error(`Failed to load language ${lng}:`, error);
//         }
//     }
// }
//
// // Preload detected language after initialization
// const detectedLanguage = i18n.language || i18n.options.fallbackLng;
//
// if (
//     detectedLanguage &&
//     detectedLanguage !== "en" &&
//     // @ts-ignore
//     languageLoaders[detectedLanguage]
// ) {
//     // Load detected language asynchronously after initial render
//     setTimeout(() => {
//         // @ts-ignore
//         loadLanguage(detectedLanguage).catch(console.error);
//     }, 0);
// }
//
// export default i18n;
//
// // import i18n from "i18next";
// // import { initReactI18next } from "react-i18next";
// // import LanguageDetector from "i18next-browser-languagedetector";
// //
// // import english from "./i18n/english.json";
// //
// // export const defaultNS = "translation";
// //
// // // Lazy language loaders
// // const languageLoaders: Record<string, () => Promise<any>> = {
// //     hi: () => import("./i18n/hindi.json"),
// //     kn: () => import("./i18n/kannada.json"),
// //     mr: () => import("./i18n/marathi.json"),
// //     tl: () => import("./i18n/telugu.json"),
// //     ta: () => import("./i18n/tamil.json"),
// // };
// //
// // i18n.use(LanguageDetector)
// //     .use(initReactI18next)
// //     .init({
// //         resources: {
// //             en: {
// //                 translation: english,
// //             },
// //         },
// //
// //         lng: "en",
// //         fallbackLng: "en",
// //
// //         defaultNS,
// //
// //         react: {
// //             useSuspense: false,
// //         },
// //
// //         interpolation: {
// //             escapeValue: false,
// //         },
// //
// //         detection: {
// //             order: ["localStorage", "navigator"],
// //             caches: ["localStorage"],
// //         },
// //     });
// //
// // // Load language dynamically
// // export async function loadLanguage(lng: string): Promise<void> {
// //     // Already loaded
// //     if (i18n.hasResourceBundle(lng, defaultNS)) {
// //         await i18n.changeLanguage(lng);
// //         return;
// //     }
// //
// //     const loader = languageLoaders[lng];
// //
// //     if (!loader) {
// //         console.error(`Language loader not found for ${lng}`);
// //         return;
// //     }
// //
// //     try {
// //         const module = await loader();
// //
// //         const translations = module.default || module;
// //
// //         i18n.addResourceBundle(lng, defaultNS, translations, true, true);
// //
// //         await i18n.changeLanguage(lng);
// //     } catch (error) {
// //         console.error(`Failed to load language ${lng}`, error);
// //     }
// // }
// //
// // // Load browser detected language
// // const detectedLanguage = i18n.language;
// //
// // if (detectedLanguage && detectedLanguage !== "en" && languageLoaders[detectedLanguage]) {
// //     loadLanguage(detectedLanguage);
// // }
// //
// // export default i18n;

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import english from "./i18n/english.json";
import hindi from "./i18n/hindi.json";
import kannada from "./i18n/kannada.json";
import Marathi from "./i18n/marathi.json";
import telugu from "./i18n/telugu.json";
import tamil from "./i18n/tamil.json";

export const defaultNS = "english";

const languageLoaders: Record<string, () => Promise<any>> = {
    en: () =>
        Promise.resolve({
            default: english,
        }),

    hi: () =>
        Promise.resolve({
            default: hindi,
        }),

    kn: () =>
        Promise.resolve({
            default: kannada,
        }),

    mr: () =>
        Promise.resolve({
            default: Marathi,
        }),

    tl: () =>
        Promise.resolve({
            default: telugu,
        }),

    ta: () =>
        Promise.resolve({
            default: tamil,
        }),
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        /**
         * Same as old code
         */
        resources: {
            en: english,

            hi: hindi,

            kn: kannada,

            mr: Marathi,

            tl: telugu,

            ta: tamil,
        },

        fallbackLng: "en",

        defaultNS,

        react: {
            useSuspense: false,
        },

        interpolation: {
            escapeValue: false,
        },

        detection: {
            order: ["localStorage", "navigator"],

            caches: ["localStorage"],
        },

        debug: false,
    });

/**
 * Change language
 */
export async function loadLanguage(lng: string): Promise<void> {
    try {
        const language = lng.split("-")[0];

        if (i18n.language === language) {
            return;
        }

        const loader = languageLoaders[language];

        if (!loader) {
            console.error("Language not supported:", language);

            return;
        }

        const module = await loader();

        const translations = module.default || module;

        /**
         * Add resource only if missing
         */
        if (!i18n.hasResourceBundle(language, defaultNS)) {
            i18n.addResourceBundle(language, defaultNS, translations, true, true);
        }

        await i18n.changeLanguage(language);

        console.log("Language changed:", language);
    } catch (error) {
        console.error("Language loading failed", error);
    }
}

export default i18n;
